<template>
	<div class="form-background max-width-750 pd-bottom-lg">
		<Spin :spinning="isLoading">
			<Form
				:model="formState"
				name="basic"
				:label-col="{ span: 8 }"
				:wrapper-col="{ span: 16 }"
				:colon="false"
				autocomplete="off"
			>
				<FormItem>
					<TypographyTitle :level="3">{{ $t('rover-page.roverHeader') }}</TypographyTitle>
				</FormItem>
				<FormItem
					:label="$t('rover-page.fields.label')"
					v-bind="validateInfos.label"
				>
					<Input v-model:value="formState.label" @keyup.enter="onSubmit"/>
				</FormItem>

				<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
					<Button
						type="primary"
						@click.prevent="onSubmit"
						:disabled="isLoading || isSubmitting"
						:loading="isLoading || isSubmitting"
					>
						{{ $t('rover-page.updateButtonLabel') }}
					</Button>
				</FormItem>
			</Form>
		</Spin>
	</div>
</template>

<script>
import { reactive, toRef } from 'vue';
import { TypographyTitle, Button, Form, FormItem, Input, Spin } from 'ant-design-vue';

import { useI18n } from 'vue-i18n'

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';
import { useRoverForm } from '@/components/rovers/useRoverForm';


export default {
	components: {
		TypographyTitle, Button, Form, FormItem, Input, Spin,
	},
	props: ['roverId'],
	setup(props) {
		const { t } = useI18n();
		const formState = reactive({
			label: '',
		});
		const rulesRef = reactive({
			label: [{ required: true, message: t('rover-page.messages.enterLabel') }],
		});
		const roverIdRef = toRef(props, 'roverId');
		const mountedHandler = () => {
			Api.roverGetOne(
				roverIdRef.value,
				response => {
					isLoading.value = false;
					if (response.status === 'ok') {
						formState.label = response.rover.label;
					} else {
						showErrorMessage(response.errors);
					}
				},
			);
		};
		const {
			validateInfos,
			isLoading,
			isSubmitting,
			onSubmit,
		} = useRoverForm(formState, rulesRef, roverIdRef, Api.roverUpdate, mountedHandler);

		return {
			formState,
			validateInfos,
			isLoading,
			isSubmitting,
			onSubmit,
		};
	},
}
</script>
